<dx-select-box class="objective-support-parent-selection"
               [(value)]="objective.parentObjective"
               [dataSource]="dataSource"
               [showClearButton]="true"
               [grouped]="true"
               groupTemplate="group"
               itemTemplate="item"
               displayExpr="fullName"
               [searchEnabled]="true"
               [searchExpr]="$any('fullName')"
               searchMode="contains"
               data-test="objective-supports-dropdown">
    <div *dxTemplate="let data of 'group'">
        @if (data.key === '__organisation__') {
            <div>Organisation objectives</div>
        } @else if (data.key === '__thisTeam__') {
            <div>This team objectives</div>
        } @else {
            <div>{{ data.key }}</div>
        }
    </div>
    <div *dxTemplate="let obj of 'item'">
        <adapt-link-objective [objective]="obj"
                              [generateHref]="false"
                              [showStatusIcon]="false"></adapt-link-objective>
    </div>
</dx-select-box>
